import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const LOGO_URL = "https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1780693784/BOTG_Logo_o9fcqe.png";

export default function Contact() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 flex flex-col justify-center items-center font-sans">
      <div className="max-w-md w-full">
        <div className="flex justify-center mb-10 cursor-pointer" onClick={() => navigate('/')}>
          <img src={LOGO_URL} alt="BookOTG" className="h-16 object-contain" />
        </div>

        <div className="bg-white rounded-[2.5rem] shadow-xl border border-gray-100 p-10 text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-primary"></div>
          
          <div className="w-20 h-20 bg-blue-50 text-brand-primary rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm ring-4 ring-blue-50/50">
            <SafeIcon name="Mail" className="text-3xl" />
          </div>

          <h1 className="text-3xl font-black text-brand-dark tracking-tight mb-4">Contact Us</h1>
          
          <p className="text-gray-500 font-medium mb-8 leading-relaxed">
            We're here to help! Send us an email and our dedicated support team will get back to you within <strong className="text-brand-dark">24 hours</strong>.
          </p>

          <a 
            href="mailto:help@bookotg.com"
            className="inline-flex items-center justify-center w-full py-4 px-6 bg-brand-primary text-white font-black rounded-2xl hover:bg-brand-accent transition-colors shadow-lg shadow-brand-primary/20 gap-3 text-lg"
          >
            <SafeIcon name="Send" />
            help@bookotg.com
          </a>

          <div className="mt-8 pt-6 border-t border-gray-100">
            <button 
              onClick={() => navigate('/')}
              className="text-sm font-bold text-gray-400 hover:text-brand-dark transition-colors flex items-center justify-center gap-2 mx-auto"
            >
              <SafeIcon name="ArrowLeft" /> Return to Home
            </button>
          </div>
        </div>
        
        <p className="text-center text-xs text-gray-400 font-bold uppercase tracking-widest mt-8">
          &copy; 2026 Fesy Marketing Pvt Ltd
        </p>
      </div>
    </div>
  );
}